module.exports = __webpack_public_path__ + "img/check_solid.fbaf784a.svg";